import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { RolloutFuncionarioService } from "../../services/rollout-funcionario.service";
import { NbDialogService } from "@nebular/theme";
import { HttpParams } from "@angular/common/http";
import { NgxSpinnerService } from "ngx-spinner";
import { DatatableComponent } from "@swimlane/ngx-datatable";
import { ExportCsvService } from "../../../../../../shared/services/export-csv.service";
import { ExportExcelService } from "../../../../../../shared/services/export-excel.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "app-migrar-funcionarios",
  templateUrl: "./migrar-funcionarios.component.html",
  styleUrls: ["./migrar-funcionarios.component.scss"],
})
export class MigrarFuncionariosComponent implements OnInit {
  @ViewChild("confirmationDialog", { static: true })
  confirmationDialog: TemplateRef<any>;
  @ViewChild(DatatableComponent, { static: false }) table: DatatableComponent;

  // Data for Grid
  temp = [];
  rows = [];
  loadingIndicator = true;
  reorderable = true;

  // Pagination
  page = {
    limit: 30,
  };

  // Filters
  filters = {
    nome: "",
    cpf: "",
    status: "",
  };

  constructor(
    private rolloutService: RolloutFuncionarioService,
    private dialogService: NbDialogService,
    private spinner: NgxSpinnerService,
    private exportCsvService: ExportCsvService,
    private exportExcelService: ExportExcelService,
  ) {}

  ngOnInit() {
    this.fetchData();
  }

  setPage(pageInfo) {
    this.table.offset = pageInfo.offset;
  }

  fetchData() {
    this.loadingIndicator = true;
    this.spinner.show();

    this.rolloutService.listAll(
      (response: any[]) => {
        const mappedData = response;

        this.temp = mappedData;
        this.onFilter(); // Re-apply existing filters
        this.loadingIndicator = false;
        this.spinner.hide();
      },
      (error: any) => {
        console.error("Error fetching employees", error);
        this.loadingIndicator = false;
        this.spinner.hide();
      },
    );
  }

  exportData(type: string) {
    if (!this.rows || this.rows.length === 0) {
      return;
    }

    const dataToExport = this.rows.map((row) => {
      let status = "Impedido";
      if (row.dataFinalizacaoMigracao) {
        status = "Migrado";
      } else if (row.dataSolicitacaoMigracao) {
        status = "Solicitado";
      } else if (row.migracaoLiberada === "LIBERADO") {
        status = "Pendente";
      }

      return {
        nome: row.nome,
        cpf: this.formatCpf(row.cpf),
        matricula: row.matricula,
        telefoneCelular: this.formatPhone(row.telefoneCelular),
        email: row.email,
        status: status,
      };
    });

    const columns = [
      { columnName: "nome", newColumnName: "Nome" },
      { columnName: "cpf", newColumnName: "CPF" },
      { columnName: "matricula", newColumnName: "Matrícula" },
      { columnName: "telefoneCelular", newColumnName: "Telefone" },
      { columnName: "email", newColumnName: "Email" },
      { columnName: "status", newColumnName: "Status" },
    ];

    const fileName = "migracao_funcionarios";

    if (type === "excel") {
      this.exportExcelService.exportXlsx(dataToExport, columns, fileName);
    } else if (type === "csv") {
      this.exportCsvService.exportCsv(dataToExport, columns, ";", fileName);
    }
  }

  private formatCpf(cpf: string): string {
    if (!cpf) return "";
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
  }

  private formatPhone(phone: string): string {
    if (!phone) return "";
    // Simple verification for 11 or 10 digits
    if (phone.length === 11) {
      return phone.replace(/(\d{2})(\d{5})(\d{4})/, "($1) $2-$3");
    } else if (phone.length === 10) {
      return phone.replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3");
    }
    return phone;
  }

  onFilter() {
    this.rows = this.temp.filter((row) => {
      const matchesNome =
        !this.filters.nome ||
        (row.nome &&
          row.nome.toLowerCase().includes(this.filters.nome.toLowerCase()));
      const matchesCpf =
        !this.filters.cpf || (row.cpf && row.cpf.includes(this.filters.cpf));

      let rowStatus = "Impedido";
      if (row.dataFinalizacaoMigracao) {
        rowStatus = "Migrado";
      } else if (row.dataSolicitacaoMigracao) {
        rowStatus = "Solicitado";
      } else if (row.migracaoLiberada === "LIBERADO") {
        rowStatus = "Pendente";
      }

      const matchesStatus =
        !this.filters.status || rowStatus === this.filters.status;

      return matchesNome && matchesCpf && matchesStatus;
    });
  }

  migrateUser(row) {
    this.dialogService.open(this.confirmationDialog, {
      context: {
        title: "Confirmar Migração",
        message: `Tem certeza que deseja solicitar a migração do funcionário '${row.nome}'? Esta ação transferirá os dados para o novo sistema de forma definitiva.`,
        action: () => this.doMigrateUser(row),
      },
    });
  }

  doMigrateUser(row) {
    this.spinner.show();
    const payload = this.buildMigrationPayload([row]);

    this.rolloutService.migrate(
      payload,
      () => {
        this.spinner.hide();
        // this.doRemoveRow(row);
        this.dialogService.open(this.confirmationDialog, {
          context: {
            title: "Sucesso",
            message: `Migração solicitada com sucesso para '${row.nome}'.`,
            confirmText: "OK",
            onlyConfirm: true,
            action: () => this.fetchData(),
          },
        });
      },
      (error) => {
        this.spinner.hide();
        console.error("Migration error", error);
        // Toast or notification could be added here
      },
    );
  }

  doRemoveRow(row) {
    // Remove from the source of truth
    this.temp = this.temp.filter((r) => r !== row);
    // Re-apply filter to update the view
    this.onFilter();
  }

  migrateAll() {
    // Filter only Pending items
    const pendingRows = this.rows.filter(
      (row) =>
        !row.dataSolicitacaoMigracao &&
        !row.dataFinalizacaoMigracao &&
        row.migracaoLiberada === "LIBERADO",
    );

    if (pendingRows.length === 0) {
      this.dialogService.open(this.confirmationDialog, {
        context: {
          title: "Aviso",
          message: "Não há registros pendentes para migrar na lista atual.",
          confirmText: "OK",
          onlyConfirm: true,
          action: () => {},
        },
      });
      return;
    }

    this.dialogService.open(this.confirmationDialog, {
      context: {
        title: "Confirmar Migração em Massa",
        message: `ATENÇÃO: Você está prestes a solicitar a migração de ${pendingRows.length} funcionário(s). Deseja continuar?`,
        action: () => this.doMigrateAll(pendingRows),
      },
    });
  }

  doMigrateAll(rowsToMigrate: any[]) {
    this.spinner.show();

    const payload = this.buildMigrationPayload(rowsToMigrate);

    this.rolloutService.migrate(
      payload,
      () => {
        this.spinner.hide();
        // this.rows.forEach(row => this.doRemoveRow(row)); // Remove all migrated
        // Or simply:
        // this.temp = this.temp.filter(r => !this.rows.includes(r));
        // this.onFilter();

        this.dialogService.open(this.confirmationDialog, {
          context: {
            title: "Sucesso",
            message: `Migração em massa solicitada com sucesso.`,
            confirmText: "OK",
            onlyConfirm: true,
            action: () => this.fetchData(),
          },
        });
      },
      (error) => {
        this.spinner.hide();
        console.error("Migration error", error);
      },
    );
  }

  private buildMigrationPayload(beneficiaries: any[]) {
    return beneficiaries.map((b) => b.pessoaId);
  }
}
